import React, { Component } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { connect } from 'react-redux'
import Baccarat from './components/pages/baccarat'
import Slotz from './components/pages/slotz'
import Login from './components/pages/login'
import Loading from './components/pages/loading'
import AppState from './components/appState'
import { Provider } from 'react-redux'
import configureStore from "./redux/store"
import * as InAppPurchases from 'expo-in-app-purchases';
import * as Facebook from 'expo-facebook';
import * as Font from 'expo-font';
import 'react-toastify/dist/ReactToastify.css';
import { PersistGate } from 'redux-persist/integration/react'
import { REACT_APP_FACEBOOK_APP_ID } from 'react-native-dotenv'
import GameChoosing from './components/pages/game-choosing';
import { SafeAreaProvider } from 'react-native-safe-area-context';

const mapStateToProps = state => {
  return {
      auth: state.auth,
      subscription: state.auth.subscription,
      subscription_expire: state.auth.subscription_expire,
  };
};

const {store, persistor } = configureStore();

const Content = connect(mapStateToProps)(({ auth, subscription, subscription_expire }) => {

  const [activeGame, setActiveGame] = React.useState({ game: false, room: 'sa'})
  // const [activeRoom, setActiveRoom] = React.useState('sa')

  const { game, room } = activeGame

  if (auth && (auth.facebook_id || auth.user_id)) {
    switch(game) {
      case 'baccarat': return <Baccarat subscription={subscription} subscription_expire={subscription_expire} vendor={room} onChooseGame={() => setActiveGame({ game: false, room: 'sa'})} />;
      case 'slot': return <Slotz vendor={room} token={auth.jwt_token} subscription={subscription} subscription_expire={subscription_expire} onChooseGame={() => setActiveGame({ game: false, room: 'sa'})} />;
    }

    return <GameChoosing subscription={subscription} subscription_expire={subscription_expire}  callback={(game, room) => { 
      setActiveGame({ game, room })
    }} />
  } else {
    return <><Login /></>
  }
});

export default class App extends Component {
  state = {
    loaded: false,
    game: false,
    fontsLoaded: false,
  }

  async loadFonts() {
    // console.log([PromptRegular.default, PromptSemiBold, PromptLight])
    const fonts = {
      'Prompt': require('./assets/fonts/Prompt-Regular.ttf'),
      'Prompt-SemiBold': require('./assets/fonts/Prompt-SemiBold.ttf'), 
      'Prompt-Light': require('./assets/fonts/Prompt-Light.ttf'), 
    }

    let finalFonts = {};
    Object.keys(fonts).forEach((key) => {
      finalFonts[key] = fonts[key].default || fonts[key]; // support require or import
    });

    console.log(finalFonts)

    await Font.loadAsync(finalFonts);
    
    this.setState({ fontsLoaded: true });
  }

  async componentDidMount() {
    try{ 
      
      if (Platform.OS !== 'web') {
        await Facebook.initializeAsync(REACT_APP_FACEBOOK_APP_ID)
        const resp = await InAppPurchases.connectAsync()
      }

    } catch(err) {
      
    }

    this.loadFonts()

    this.setState({loaded: true})
  }

  render() {
    
    return (
      <Provider store={store}>
        <PersistGate loading={<Loading />} persistor={persistor}>
          <SafeAreaProvider>
            <View style={styles.container}>
              {this.state.loaded ? <Content /> : <Loading />}
            </View>
          </SafeAreaProvider>
          <AppState />
        </PersistGate>
      </Provider>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  } 
});


